import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CookieBar from '../CookieBar';
import FloatingContactButton from '../FloatingContactButton';
import PreviewBanner from '../PreviewBanner';
import { SiteHeader } from './SiteHeader';
import { HeroBlock } from './HeroBlock';
import { FeaturesBlock } from './FeaturesBlock';
import { BreadcrumbsBlock, FaqBlock, StepsBlock, TableBlock, VersionsBlock } from './DetailBlocks';
import { MediaBlock } from './MediaBlock';
import { ContactBlock } from './ContactBlock';
import { SiteFooter } from './SiteFooter';
import './public-site.css';
import { ResponsiveTypography, BlockTypography } from './Typography';

const blocksRegistry = { hero: HeroBlock, features: FeaturesBlock, breadcrumbs: BreadcrumbsBlock, faq: FaqBlock, steps: StepsBlock, table: TableBlock, versions: VersionsBlock, image_text: MediaBlock, contact: ContactBlock, footer: SiteFooter };

export const PublicSite = ({ config, blocks, navigation, sharedHeader, onLogoClick, renderFallback, isHome }) => {
  const location = useLocation();
  const navOpacity = navigation?.style?.bgOpacity ?? 95;
  const overlayNav = sharedHeader && navOpacity < 100 && navigation?.sticky !== false;
  useEffect(() => { if (!location.hash) window.scrollTo({ top: 0, behavior: 'instant' }); }, [location.pathname, location.hash]);
  return <ResponsiveTypography><div className={`tdp-site ${overlayNav ? 'tdp-has-overlay' : ''}`} data-testid="public-site">
  <a className="tdp-skip" href="#public-main" data-testid="skip-to-content">Přejít na obsah</a>
  <PreviewBanner info={config._preview} />
  {sharedHeader && <SiteHeader config={config} navigation={navigation} onLogoClick={onLogoClick} />}
  <main id="public-main">{blocks.filter(b => b.type !== 'footer').map(block => {
    const Component = block.content?.publicDesign === 'classic' ? null : blocksRegistry[block.type];
    return <BlockTypography block={block} key={block.id}>{Component ? <Component block={block} isHome={isHome} /> : renderFallback(block)}</BlockTypography>;
  })}</main>
  {blocks.filter(b => b.type === 'footer').map(block => <BlockTypography key={block.id} block={block}><SiteFooter block={block} navigation={navigation} /></BlockTypography>)}
  <FloatingContactButton config={config.settings?.floatingContact || {}} />
  <CookieBar />
</div></ResponsiveTypography>;
};